import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { filter, Subject, takeUntil } from 'rxjs';
import { CommonUtilsService } from '../../services/commonutils/common-utils.service';

import { AssetData } from '../../models/assetdata.class';
import { GetPreCapturedAttributes } from '../../store/actions';
import { getPreCapturedAttributes$ } from '../../store/selectors';

@Component({
    selector: 'app-pre-captured-attributes-dialog',
    templateUrl: './pre-captured-attributes-dialog.component.html',
    styleUrls: ['./pre-captured-attributes-dialog.component.scss'],
    standalone: false,
})
export class PreCapturedAttributesDialogComponent implements OnDestroy, OnInit {
    @Input() public instanceId: string;
    @Input() public metaData: AssetData;

    private unSubscribe = new Subject<void>();
    public preCapturedAttributes: any = [];

    constructor(
        private _commonUtils: CommonUtilsService,
        private store$: Store,
        private dialogRef: MatDialogRef<PreCapturedAttributesDialogComponent>
    ) {}

    private getFilingAttributes = () => {
        this.store$.dispatch(GetPreCapturedAttributes({ instanceId: this.instanceId }));
    };

    closeModal = () => {
        this.dialogRef.close();
    };

    ngOnInit(): void {
        this.store$
            .select(getPreCapturedAttributes$)
            .pipe(
                takeUntil(this.unSubscribe),
                filter(data => data !== undefined)
            )
            .subscribe(attributes => {
                const attributesList = CommonUtilsService.cloneObject(attributes[this.instanceId] || []);
                attributesList?.forEach(attribute => {
                    const [entityId, fieldId] = attribute.keyId.split('^');
                    const entity = this.metaData.getEntity(entityId);
                    const field = entity?.getField(fieldId);
                    attribute.displayName = field?.displayName || field?.name || attribute.entityName;
                    if (attribute.dataType === 'date') {
                        attribute.value = this._commonUtils.transformDateToLocale(
                            attribute.value,
                            attribute.outputFormat as any,
                            (attribute.outputFormat as any) || 'ddMMMyyyy',
                            true
                        );
                    }
                });
                this.preCapturedAttributes = attributesList;
            });

        this.getFilingAttributes();
    }

    ngOnDestroy(): void {
        this.unSubscribe.next();
        this.unSubscribe.complete();
    }
}
